export default "__VITE_ASSET__DXn5YoW0__"